import { render, staticRenderFns } from "./Assignments.vue?vue&type=template&id=23ff3666&"
import script from "./Assignments.vue?vue&type=script&lang=js&"
export * from "./Assignments.vue?vue&type=script&lang=js&"
import style0 from "./Assignments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAvatar,VBtn})
